export function normalizeError(error, fallbackMessage) {
  if (error instanceof Error) {
    return error;
  }
  return new Error(String(error || fallbackMessage));
}
